import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/shared/components';
import { primeAbpAntiforgerySession } from '@/shared/api';
import { useLoginMutation } from '../hooks/useLoginMutation';
import { LoginForm } from '../components/LoginForm';
import type { LoginFormValues } from '../components/LoginForm';

export function LoginPage() {
  const navigate = useNavigate();
  const mutation = useLoginMutation();

  useEffect(() => {
    void primeAbpAntiforgerySession();
  }, []);

  const handleSubmit = async (values: LoginFormValues) => {
    await mutation.mutateAsync(values);
    navigate('/', { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f0f4f8] px-4">
      <div className="w-full max-w-md space-y-8 text-center">
        <PageHeader
          title="Sign in"
          description="Sign in to Mehe Reporting with your account."
        />
        <div className="flex justify-center">
          <LoginForm
            onSubmit={handleSubmit}
            isLoading={mutation.isPending}
            error={mutation.error ?? null}
          />
        </div>
      </div>
    </div>
  );
}
